import { useLanguage } from "../i18n/LanguageContext";

export function SignalsMarquee() {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div
      className="relative border-y border-white/10 bg-[#0A0A0C] py-5 overflow-hidden"
      data-testid="signals-marquee"
    >
      <div className="marquee-track">
        {items.map((item, i) => (
          <div key={i} className="flex items-center shrink-0 px-8">
            <span className="font-display font-medium text-xl sm:text-2xl text-zinc-600 tracking-tight whitespace-nowrap">
              {item}
            </span>
            <span className="mx-8 w-1.5 h-1.5 rounded-full bg-[#00F0FF]/60" />
          </div>
        ))}
      </div>
    </div>
  );
}
